<template>
    <MainLayout>
        <div class="container">
            <b-row>
                <b-col lg="3">
                    <div class="mb-3">
                        <label for="ambiente-select" class="form-label">Ambiente:</label>
                        <b-form-select
                            id="ambiente-select"
                            v-model="ambiente"
                            :options="ambientes"
                            @change="recargarConParametros"
                        ></b-form-select>
                    </div>
                </b-col>
                <b-col lg="3">
                    <div class="mb-3">
                        <label for="lang-select" class="form-label">Idioma:</label>
                        <b-form-select
                            id="lang-select"
                            v-model="lang"
                            :options="idiomas"
                            @change="recargarWidget"
                        ></b-form-select>
                    </div>
                </b-col>
                <b-col lg="3">
                    <div class="mb-3">
                        <label for="currency-select" class="form-label">Moneda:</label>
                        <b-form-select
                            id="currency-select"
                            v-model="currency"
                            :options="monedas"
                            @change="recargarWidget"
                        ></b-form-select>
                    </div>
                </b-col>
            </b-row>
            <b-card>
                <div
                id="shuttle-central-booking-v2"
                pickup="CUN"
                flight-number="VB2163"
                service-date="2026-05-23"
                return-service-date="2026-05-27"
                return-flight-number="VB2180"
                adults="2"
                children="1"
                infants="0"
                first-name="Juan"
                last-name="Pérez"
                email="juan@ejemplo.com"
                phone="+529981234567"
                :currency="currency"
                :lang="lang"
                trip-type="roundtrip"
                sales-channel-reference=""
                enable-modal="false"
                ></div>

            </b-card>
        </div>
    </MainLayout>
</template>

<script>

import MainLayout from '../layout/MainLayout.vue'
export default {
    components: {MainLayout},
    data() {
        // Leer parámetros de la URL
        const params = new URLSearchParams(window.location.search)
        return {
            ambiente: params.get('ambiente') || 'sandbox',
            ambientes: [
                { value: 'sandbox', text: 'Sandbox' },
                { value: 'productivo', text: 'Productivo' }
            ],
            lang: params.get('lang') || 'es',
            idiomas: [
                { value: 'es', text: 'Español' },
                { value: 'en', text: 'English' }
            ],
            currency: params.get('currency') || 'mxn',
            monedas: [
                { value: 'mxn', text: 'MXN (Peso Mexicano)' },
                { value: 'usd', text: 'USD (Dólar)' }
            ]
        }
    },
    computed: {
        baseUrl() {
            return this.ambiente === 'sandbox'
                ? 'https://vivaaerobus.sandbox.shuttlecentral.com'
                : 'https://shuttles.vivaaerobus.com'
        }
    },
    methods: {
        recargarConParametros() {
            const params = new URLSearchParams()
            params.set('ambiente', this.ambiente)
            params.set('lang', this.lang)
            params.set('currency', this.currency)
            window.location.href = `${window.location.pathname}?${params.toString()}`
        },
        recargarWidget() {
            this.$nextTick(() => {
                // Remover script anterior
                const oldScript = document.getElementById('widget-loader-script')
                if (oldScript) {
                    oldScript.remove()
                }
                // Limpiar contenedor
                const container = document.getElementById('shuttle-central-booking-v2')
                if (container) {
                    container.innerHTML = ''
                }
                // Recargar script
                this.$nextTick(() => {
                    this.cargarWidget()
                })
            })
        },
        cargarWidget() {
            const script = document.createElement('script')
            script.id = 'widget-loader-script'
            script.src = `${this.baseUrl}/widget-loader-v2.js`
            script.setAttribute('be', this.baseUrl)
            document.body.appendChild(script)
        }
    },
    mounted() {
        this.cargarWidget()
    }
}
</script>
<style scoped>
.container {
    max-width: 1200px;
}

.card-body {
    padding: 0px;
}
</style>